import { UserID } from "./User";

export type NotificationEntityID = number;

export type NotificationFieldID = number;

export type NotificationElementID = number;

export enum NOTIFICATION_ENTITY_TEMPLATE {
  CheckBoxes = 1,
  DropdownMulti = 2
}

export interface NotificationEntity {
  notification_entity_id: NotificationEntityID;
  name: string; // Name of the entity
  template_id: NOTIFICATION_ENTITY_TEMPLATE; // Identifier for the entity template
}

export interface NotificationField {
  notification_field_id: NotificationFieldID;
  name: string; // Name of the field
  value: string; // Value of the field
  icon: string; // Icon of the field to be displayed in frontend
  sub_icon: string; // Sub icon of the field to be displayed in frontend
}

export interface NotificationElement {
  notification_element_id: NotificationElementID; // Identifier for the notification element
  notification_entity_id: NotificationEntityID; // Identifier for the notification entity
  notification_field_id: NotificationFieldID; // Identifier for the notification field
  entity?: NotificationEntity;
  field?: NotificationField;
  user_id?: UserID;
}
